import React, { useEffect } from 'react';
import './wizard-modal.css';
import ChoiceCard from './choice-card';
import FrequencySelector from './frequency-selector';
import NavigationButton from './navigation-button';

const WizardModal = ({ isOpen, onClose, modalConfig, onSelect, onSelectChange, onValidate, selectedChoice, selectedValue, onHelpClick }) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (isOpen && event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscKey);
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose, isOpen]);

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  if (!modalConfig) return null;

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose} 
      style={{ display: isOpen ? 'flex' : 'none' }}
    >
      <div className="modal-content" onClick={handleContentClick}>
        <button className="close-button" onClick={onClose}>
          X
        </button>
        
        <div className="modal-header">
          <h2 className="modal-title">
            <span>{modalConfig.label}</span>
          </h2>
          {modalConfig.sublabel && (
            <p className="modal-subtitle" dangerouslySetInnerHTML={{ __html: modalConfig.sublabel }} />
          )}
        </div>
        
        <div className="modal-body">
          <div className="modal-choices">
            {modalConfig.choices && modalConfig.choices.map((choice, index) => {
              const isSelected = selectedChoice && 
                selectedChoice.img === choice.img && 
                selectedChoice["subscriber-price"] === choice["subscriber-price"];
              
              const canShowSelector = isSelected && choice.select;
              
              return (
                <div className={`modal-choice-container ${canShowSelector ? 'with-selector' : ''}`} key={index}>
                  <div className="modal-choice-img-container">
                    <ChoiceCard
                      choice={choice}
                      isSelected={isSelected}
                      onSelect={() => onSelect(choice, index)}
                      onHelpClick={onHelpClick}
                      reduced={false}
                    />
                  </div>
                  
                  {canShowSelector && (
                    <div className="modal-choice-selector-container">
                      <FrequencySelector
                        selectedChoice={selectedChoice}
                        onSelectChange={onSelectChange}
                        selectedValue={selectedValue}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        
        <div className="modal-footer">
          <div className="modal-navigation-button-container">
            <NavigationButton
              isEnabled={!!selectedChoice}
              onClick={onValidate}
              label="Valider"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WizardModal;